function NoAuth() {
  return (
    <>
      <h2>Not Authorised</h2>
    </>
  );
}

export default NoAuth;
